import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'EventQuestsSubLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '39aa4fe6-2777-4d49-b9ad-6df49af3231d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_board',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: '13e521b5-fc5d-4ffc-8946-ea0a4f8f7df1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -10,
      y: -222,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_timer',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: '02444825-d5d9-4a4a-8760-3084104d3628',
      type: 'Sprite',
      name: 'eventBG',
      nameSpace: '',
      className: '',
      x: 0,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'xmas_2021_collectStars',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'd48151bd-fad1-4355-8001-e4f1263a2262',
      type: 'Sprite',
      name: 'shadowSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_shadow',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      type: 'Sprite',
      name: 'giftDetailsSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: -127,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_reward_preview',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: '469bcb83-5a36-43f9-abbd-8991b0ccb199',
      type: 'Text',
      name: 'timeText',
      nameSpace: '',
      className: '',
      x: 19,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '',
      localize: false,
      maxWidth: 100,
      maxHeight: 34,
      maxFontSize: 27,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: '#692012',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '13e521b5-fc5d-4ffc-8946-ea0a4f8f7df1',
      data: ''
    },
    {
      id: 'e5535388-1a25-412b-a71b-58f606fa8230',
      type: 'Sprite',
      name: 'activeContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 86,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_panel_bg',
      parent: '02444825-d5d9-4a4a-8760-3084104d3628',
      data: ''
    },
    {
      id: '6d759bcd-e960-4feb-a50e-39e3fb9862b5',
      type: 'Sprite',
      name: 'lockSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_lock',
      parent: 'd48151bd-fad1-4355-8001-e4f1263a2262',
      data: ''
    },
    {
      id: 'b27421e5-6fd5-462c-bfc7-79082064dade',
      type: 'Sprite',
      name: 'bigCheckSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_check',
      parent: 'd48151bd-fad1-4355-8001-e4f1263a2262',
      data: ''
    },
    {
      id: 'd33120f4-9870-44a9-8240-4df9b075a433',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ClickToContinue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '273fcce1-f100-4a89-9e14-13265894faf4',
      data: ''
    },
    {
      id: '2befddf7-4773-427f-9d18-cde495aba28c',
      type: 'Sprite',
      name: 'itemSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: -78,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      data: ''
    },
    {
      id: 'aaef061a-285c-465a-9883-cc3dd715771a',
      type: 'Text',
      name: 'itemText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Name of item',
      localize: false,
      maxWidth: 220,
      maxHeight: 36,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ba372b',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      data: ''
    },
    {
      id: 'cdbfa411-dde0-4739-a551-8fb1648c4725',
      type: 'Text',
      name: 'rewardText',
      nameSpace: '',
      className: '',
      x: 21,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1000 coins',
      localize: false,
      maxWidth: 154,
      maxHeight: 36,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ba372b',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      data: ''
    },
    {
      id: 'ea431fa3-2b3a-44ba-96cd-1078c6c59499',
      type: 'Sprite',
      name: 'rewardSprite',
      nameSpace: '',
      className: '',
      x: -72,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_coin',
      parent: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      data: ''
    },
    {
      id: '30731bd4-5ac7-4426-8e64-d3c6a9e71540',
      type: 'Text',
      name: 'SPPointsText',
      nameSpace: '',
      className: '',
      x: -40,
      y: 95,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3',
      localize: false,
      maxWidth: 154,
      maxHeight: 36,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ba372b',
        stroke: '#933019',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      data: ''
    },
    {
      id: '838f5450-5a8f-40e4-b1ad-0d8560b6cf1f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -72,
      y: 95,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpoints_icon_small',
      parent: 'cd53a7e6-d895-4ef0-bbb0-092b84793246',
      data: ''
    },
    {
      id: '4461311d-eca8-490c-8050-5e06231e181a',
      type: 'Text',
      name: 'missionText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -102,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collect 10 stars',
      localize: false,
      maxWidth: 230,
      maxHeight: 35,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8c3d35',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e5535388-1a25-412b-a71b-58f606fa8230',
      data: ''
    },
    {
      id: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
      type: 'Sprite',
      name: 'progressBar',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_bar_back',
      parent: 'e5535388-1a25-412b-a71b-58f606fa8230',
      data: ''
    },
    {
      id: 'b84688c2-9702-42c4-aa4f-5db7080f2693',
      type: 'Container',
      name: 'completedDBContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 72,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8bf1874e-db14-4f55-b678-9bb33ffcfdf4',
      data: ''
    },
    {
      id: 'e530fbac-5d2e-4123-9493-9da3d14277c9',
      type: 'Text',
      name: 'completeText',
      nameSpace: '',
      className: '',
      x: -50,
      y: 125,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Completed',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: 'white',
        stroke: '#8c3d35',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8bf1874e-db14-4f55-b678-9bb33ffcfdf4',
      data: ''
    },
    {
      id: '51299b50-b9d8-4e3f-9898-5fa266746a86',
      type: 'Text',
      name: 'lockText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 105,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 54',
      localize: false,
      maxWidth: 210,
      maxHeight: 50,
      maxFontSize: 33,
      icons: [],
      style: {
        fontSize: 33,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: 'black',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6d759bcd-e960-4feb-a50e-39e3fb9862b5',
      data: ''
    },
    {
      id: '5661801f-4cb1-48f2-bf81-11b3c93dc6e0',
      type: 'NineSlicePlane',
      name: 'progressBarFill',
      nameSpace: '',
      className: '',
      x: 2,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 121,
        y: 20
      },
      width: 241,
      height: 40,
      leftWidth: 16,
      topHeight: 8,
      rightWidth: 16,
      bottomHeight: 8,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_bar_green',
      parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
      data: ''
    },
    {
      id: '2b7e8b88-1a68-4c87-943f-076091823d5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 41,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_bar_below',
      parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
      data: ''
    },
    {
      id: '329ba0b9-30ee-4be2-808f-7cabd9cc9d84',
      type: 'Sprite',
      name: 'progressBarFrontSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_bar_front',
      parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
      data: ''
    },
    {
      id: '4de813c8-d1fc-48e0-b0f8-1e498fedb75d',
      type: 'Sprite',
      name: 'giftTooltip',
      nameSpace: '',
      className: '',
      x: -83,
      y: -12,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_for_gift',
      parent: 'b3549137-37b2-4dde-b0fc-b564f471b10a',
      data: ''
    },
    {
      id: '80393e63-9adc-4510-9fd5-e13c0991e981',
      type: 'Text',
      name: 'progressText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '23 / 100',
      localize: false,
      maxWidth: 139,
      maxHeight: 40,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#002424',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2b7e8b88-1a68-4c87-943f-076091823d5b',
      data: ''
    },
    {
      id: 'dad2330c-10a0-4741-801a-8ba02993d370',
      type: 'Text',
      name: 'giftText',
      nameSpace: '',
      className: 'giftTooltipText',
      x: 0,
      y: -58,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '20',
      localize: false,
      maxWidth: 43,
      maxHeight: 18,
      maxFontSize: 16,
      icons: [],
      style: {
        fontSize: 16,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#671e0a',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4de813c8-d1fc-48e0-b0f8-1e498fedb75d',
      data: ''
    },
    {
      id: '33739bd4-2516-476f-ad11-b07bdeaf0a15',
      type: 'Sprite',
      name: 'giftSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: -32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'event_mission_coin',
      parent: '4de813c8-d1fc-48e0-b0f8-1e498fedb75d',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class EventQuestsSubLayout {
  static raw = raw;
  root: PIXI.Container
  timeText: PIXI.Text
  eventBG: PIXI.Sprite
  activeContainer: PIXI.Sprite
  missionText: PIXI.Text
  progressBar: PIXI.Sprite
  progressBarFill: PIXI.NineSlicePlane
  progressText: PIXI.Text
  progressBarFrontSprite: PIXI.Sprite
  giftTooltip: PIXI.Sprite
  giftText: PIXI.Text
  giftTooltipComplete: PIXI.Sprite
  completedContainer: PIXI.Sprite
  completedDBContainer: PIXI.Container
  completeText: PIXI.Text
  shadowSprite: PIXI.Sprite
  lockSprite: PIXI.Sprite
  lockText: PIXI.Text
  bigCheckSprite: PIXI.Sprite
  overlay: PIXI.Graphics
  noTextOverlay: PIXI.Graphics
  giftDetailsSprite: PIXI.Sprite
  itemSprite: PIXI.Sprite
  itemText: PIXI.Text
  rewardText: PIXI.Text
  rewardSprite: PIXI.Sprite
  SPPointsText: PIXI.Text
  SPPointsIcon: PIXI.Sprite
  giftTooltipBox: (PIXI.Sprite)[]
  giftTooltipText: (PIXI.Text)[]
  giftTooltipBoxComplete: (PIXI.Sprite)[]
  giftTooltipTextComplete: (PIXI.Text)[]

  constructor() {
    populate(this, raw);
  }
}
